import {
  LetterheadBackgroundColor,
  LetterheadDetailFragment,
  ThumbnailFileFragment,
} from 'types/graphql'

export enum CenterType {
  TEXT = 'Text',
  FILE = 'File',
}

export type LetterheadFormValues = {
  backgroundColor: LetterheadBackgroundColor | null
  centerFile: ThumbnailFileFragment | null
  centerFileWidthPx: number | null
  centerText: string
  centerType: CenterType
  leftText: string
  name: string
  rightText: string
}

export const getInitialFormValues = (
  letterhead: LetterheadDetailFragment | null | undefined
): LetterheadFormValues => {
  if (!letterhead) {
    // For new letterheads, use null values - the backend will apply defaults
    return {
      backgroundColor: null,
      centerFile: null,
      centerFileWidthPx: null,
      centerText: '',
      centerType: CenterType.TEXT,
      leftText: '',
      name: '',
      rightText: '',
    }
  }

  return {
    backgroundColor: letterhead.backgroundColor ?? null,
    centerFile: letterhead.centerFile ?? null,
    centerFileWidthPx: letterhead.centerFileWidthPx ?? null,
    centerText: letterhead.centerText ?? '',
    centerType: letterhead.centerFile ? CenterType.FILE : CenterType.TEXT,
    leftText: letterhead.leftText,
    name: letterhead.name,
    rightText: letterhead.rightText,
  }
}
